import { render, staticRenderFns } from "./QuestionWithErrorWrap.vue?vue&type=template&id=2feb46bf&scoped=true"
import script from "./QuestionWithErrorWrap.vue?vue&type=script&lang=js"
export * from "./QuestionWithErrorWrap.vue?vue&type=script&lang=js"
import style0 from "./QuestionWithErrorWrap.vue?vue&type=style&index=0&id=2feb46bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb46bf",
  null
  
)

export default component.exports